class DateUtils {
  static dateToString (date) {
    let dd = date.getDate()
    if (dd < 10) dd = '0' + dd
    let mm = date.getMonth() + 1
    if (mm < 10) mm = '0' + mm
    let yy = date.getFullYear()
    return dd + '.' + mm + '.' + yy
  }

  static stringToDate (dateString) {
    const pattern = /(\d{2})\.(\d{2})\.(\d{4})/
    return new Date(dateString.replace(pattern, '$3-$2-$1'))
  }
}

export default DateUtils



// WEBPACK FOOTER //
// ./src/utils/DateUtils.js